import React from 'react';
import * as _ from 'lodash';
import { Alert, FormControl, FormGroup, Panel } from 'react-bootstrap';

interface IProps {
    lav10ml: number,
    pink10ml: number,
    red10ml: number,
    green10ml: number,
    yellow85ml: number,
    blue45ml: number,
    disableElements: boolean,
    onFieldChanged: (name: string, value: number) => void
}

const Tubes = (props: IProps) => {
    const handleFieldChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;

        props.onFieldChanged(name, parseInt(value));
    }

    const numbers = _.range(1, 9, 1);

    const tubeCount = props.lav10ml + props.pink10ml + props.red10ml + props.green10ml + props.yellow85ml + props.blue45ml;

    return (
        <Panel bsStyle='primary'>
            <Panel.Heading>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        Please select up to 8 blood draw tubes
                    </div>
                    
                    {tubeCount <= 8 ?
                        <div>{tubeCount} selected</div>
                        :
                        <div className='bg-yellow' style={{ paddingLeft: 5, paddingRight: 5, borderRadius: 2 }}>You cannot select more than a total of 8 tubes. Please adjust your order before continuing.</div>
                    }
                </div>
            </Panel.Heading>
            <Panel.Body>
                <FormGroup>
                    <label>Lavender Top (10ml):</label>
                    <FormControl
                        componentClass='select'
                        name='lav10ml'
                        value={props.lav10ml}
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    >
                        <option value={0}>Please Select</option>
                        {numbers.map(x =>
                            <option value={x}>{x}</option>
                        )}
                    </FormControl>
                </FormGroup>

                <FormGroup>
                    <label>Pink Top (6ml):</label>
                    <FormControl
                        componentClass='select'
                        name='pink10ml'
                        value={props.pink10ml}
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    >
                        <option value={0}>Please Select</option>
                        {numbers.map(x =>
                            <option value={x}>{x}</option>
                        )}
                    </FormControl>
                </FormGroup>

                <FormGroup>
                    <label>Red Top (10ml):</label>
                    <FormControl
                        componentClass='select'
                        name='red10ml'
                        value={props.red10ml}
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    >
                        <option value={0}>Please Select</option>
                        {numbers.map(x =>
                            <option value={x}>{x}</option>
                        )}
                    </FormControl>
                </FormGroup>

                <FormGroup>
                    <label>Green Top (10ml):</label>
                    <FormControl
                        componentClass='select'
                        name='green10ml'
                        value={props.green10ml}
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    >
                        <option value={0}>Please Select</option>
                        {numbers.map(x =>
                            <option value={x}>{x}</option>
                        )}
                    </FormControl>
                </FormGroup>

                <FormGroup>
                    <label>Yellow Top (8.5ml):</label>
                    <FormControl
                        componentClass='select'
                        name='yellow85ml'
                        value={props.yellow85ml}
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    >
                        <option value={0}>Please Select</option>
                        {numbers.map(x =>
                            <option value={x}>{x}</option>
                        )}
                    </FormControl>
                </FormGroup>

                <FormGroup>
                    <label>Blue Top (2.7ml):</label>
                    <FormControl
                        componentClass='select'
                        name='blue45ml'
                        value={props.blue45ml}
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    >
                        <option value={0}>Please Select</option>
                        {numbers.map(x =>
                            <option value={x}>{x}</option>
                        )}
                    </FormControl>
                </FormGroup>
            </Panel.Body>
        </Panel>
    );
}

export default Tubes;